import React from "react";
import { PageHead, Wrap, H2, P, Prose } from "@/components/Content";

const Section = ({ title, children }) => (
  <section className="space-y-4">
    <H2 className="!text-xl">{title}</H2>
    <Prose>{children}</Prose>
  </section>
);

export default function Privacy() {
  return (
    <div className="bg-ink min-h-screen pb-24">
      <PageHead eyebrow="Legal" title="PRIVACY POLICY" tone="cyan"
        sub="How CardScience HQ handles your information and your collection — with confidentiality as a core part of our service." />
      <Wrap className="py-16 space-y-12">
        <Section title="Confidentiality First">
          <P>Your collection is your business. Confidentiality is not an upgrade at CardScience HQ — it is part of our service. We will never intentionally disclose the identity of a client, the contents of a collection, the value of a collection, grading results, submission details or the use of our services without authorization from the client, except where disclosure is legally required.</P>
          <P>We do not require customers to publicly acknowledge that CardScience HQ worked on their collectibles, to tag us, or to reveal that a collectible was submitted to us. We do not use high-profile cards, comics or collections for advertising without permission, and we do not disclose customer collection values simply because a collection is impressive.</P>
        </Section>

        <Section title="Information We Collect">
          <P>To evaluate submissions and provide services, we may collect the details you provide (such as your name, email, phone, collectible descriptions, declared value and notes), submission and service records, shipping and tracking information, documentation (photographs and video created during intake, processing and packing), and communications with you.</P>
        </Section>

        <Section title="How We Use Information">
          <P>We use your information to evaluate collectibles, communicate approvals and shipping instructions, perform approved services, maintain our chain-of-custody and documentation process, handle shipping and insurance, and operate and protect our business.</P>
        </Section>

        <Section title="Records & Legal Disclosure">
          <P>We may preserve relevant business records, including documentation and communications, for legitimate business, security and legal purposes. Where CardScience HQ reasonably believes fraud, theft, tampering or another unlawful act may have occurred, we may report the matter to the appropriate carrier, insurer, payment provider, grading company or law-enforcement agency and may share relevant records as permitted or required by applicable law.</P>
        </Section>

        <Section title="Third Parties">
          <P>Shipping carriers, insurers and payment providers operate under their own terms and privacy practices. We share only the information necessary to provide services (such as shipping and insurance handling).</P>
        </Section>

        <Section title="Your Choices">
          <P>A collector may choose to publicly share their experience with us — that is their choice, not ours. You may contact us to ask about the information associated with your submissions.</P>
        </Section>
      </Wrap>
    </div>
  );
}
